import axios from "axios";
import React from "react";

import { Form, Formik } from "formik";
import { useLocation } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import BZLogo from "../../components/BZLogo";
import { TwMainLayout, TwPhoneInputGroup } from "../../components/tailwind";
import { useLocalStorage } from "../../hooks";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading } from "../../redux/reducers/loadingReducer";
import { userState } from "../../redux/reducers/userReducer";
import { getUrlForUsers } from "../../utils/confighelpers";
import { defaultDomainList } from "../../utils/constants";
import { useTenant } from "../../provider/TenantProvider";
import AuthShell, { AuthHeading, PrimaryAuthButton, StepBar } from "../../components/auth/AuthShell";

export default function ForgotPassword({ navigation, userType = "teacher" }) {
  const { addToast, addSuccessToast, addErrorToast } = useToast();
    const { tenant, tenantData, tenantLoading } = useTenant();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const location = useLocation();
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const userReduxState = useSelector(userState);
  const club = defaultDomainList.indexOf(tenant) < 0 && tenantData?.business_details ? tenantData.business_details : null;

  React.useEffect(() => {
    if (userToken !== undefined && userToken !== "" && userReduxState.userData?.fullName) {
      window.location.href = "/home/dashboard";
    }
  }, []);

  return (
    <TwMainLayout fullScreen={true} checkSession={false}>
      <AuthShell club={club} brandTitle="Locked out?" brandLine="We text a code to your mobile, you pick a new password.">
        {!userToken && (<div className="flex flex-col gap-6">
          <StepBar step={1} />
          <AuthHeading title="Reset your password">Enter the mobile number of your account. We'll text you a 4-digit code.</AuthHeading>
          <Formik
            initialValues={{
              countryName:
                location.state !== null ? location.state.countryName : "nl",
              countryCode:
                location.state !== null ? location.state.countryCode : "",
              phone: location.state !== null ? location.state.number : "",
              formattedPhoneNumber:
                location.state !== null
                  ? location.state.formattedPhoneNumber
                  : "",
            }}
            validate={(values) => {
              const errors = {};

              if (!values.phone) {
                errors.phone = "Required!";
              }

              return errors;
            }}
            onSubmit={async (values, { setSubmitting }) => {
              dispatch(setActionLoading(true));
              const request = await axios.post(
                `${getUrlForUsers()}forgotPassword`,
                {
                  username: values.countryCode + values.phone,
                  userType: userType,
                }
              );
              dispatch(setActionLoading(false));
              if (request.data.statusCode === 200) {
                setSubmitting(false);
                navigation("/forgot-password/verify", {
                  state: {
                    formattedPhoneNumber: values.formattedPhoneNumber,
                    countryName: values.countryName,
                    countryCode: values.countryCode,
                    phone: values.phone,
                    response: request.data,
                    userType: userType,
                  },
                });
              } else {
                setSubmitting(false);
                addErrorToast(request.data.message);
              }
            }}
          >
            {({
              values,
              errors,
              setFieldValue,
              handleBlur,
              submitForm,
              isSubmitting,
            }) => (
              <Form>
                <div className={"flex flex-col gap-5"}>
                  <TwPhoneInputGroup
                    label={"Mobile number"}
                    placeholder={"Mobile number"}
                    name={"phone"}
                    country={values.countryName}
                    onBlur={() => handleBlur("phone")}
                    onChange={(phone, country, e) => {
                      const numberWithoutDialCode = phone.split("");
                      for (let i = 0; i < country.dialCode.length; i++) {
                        numberWithoutDialCode.shift();
                      }
                      let dialCode = country.dialCode;
                      if (
                        country.format.includes("+") &&
                        !country.dialCode.includes("+")
                      ) {
                        dialCode = "+".concat(country.dialCode);
                      }
                      setFieldValue("countryName", country.countryCode);
                      setFieldValue("countryCode", dialCode);
                      setFieldValue("phone", numberWithoutDialCode.join(""));
                      setFieldValue("formattedPhoneNumber", e.target.value);
                    }}
                    errors={errors}
                  />
                  <PrimaryAuthButton busy={loadingReduxState.actionLoading || isSubmitting}>Send code</PrimaryAuthButton>
                </div>
              </Form>
            )}
          </Formik>
          <p className="text-center text-[15px] text-gray-600">
            Remembered it?{" "}
            <button type="button" className="font-extrabold text-indigo-bz hover:underline" onClick={() => navigation(userType === "student" ? "/members/signin" : "/")}>Back to sign in</button>
          </p>
        </div>)}
      </AuthShell>
    </TwMainLayout>)
}
